export function downloadCSV(data, fileName) {
  if (!data.length) return;

  const fields = Object.keys(data[0]);

  const csvData = [
    fields,
    ...data.map(row => fields.map(field => row[field] ?? ""))
  ];

  const csvContent = csvData
    .map(row =>
      row
        .map(value => `"${String(value).replace(/"/g, '""')}"`)
        .join(",")
    )
    .join("\n");

  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = `${fileName}.csv`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
